<section class="hero">
    <section class="title">
        <h1 class="text-box">
            Existimos para tornar a
            <span class="blue">doação</span>
           parte do
            <span class="green">
                cotidiano brasileiro
            </span>
        </h1>
        <a href="https://www.youtube.com/watch?v=Kn_N0fkOXLA&ab_channel=DiadeDoar" target="_blank" class="round background-dark-blue"
            mat-button>Assista
            como funciona</a>
    </section>
    <section class="pictures">
        <img src="assets/banners/banner_home.png" alt="picture">
    </section>
</section>